export const PERSONALIZATION_TOKEN_TAG = 'ptoken';
